import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.secondary.contrastText,
    fontSize: 15,
    fontWeight: 700,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: 500,
    color: '#2e263de6',
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  transition: theme.transitions.create(['background-color'], {
    duration: theme.transitions.duration.shortest,
  }),

  '&:hover': {
    backgroundColor: theme.palette.action.hover, // Un gris sumamente sutil (normalmente #F5F5F5 o similar)
    cursor: 'pointer', // Indica al usuario que la fila es interactiva
  },

  // Quitar el borde inferior a la última fila para un acabado limpio si la tabla tiene contenedor
  '&:last-child td, &:last-child th': {
    borderBottom: 0,
  },
}));
